import {IWixSdk, WixSdk} from '@wix/js-sdk-wrapper';
import {Container} from 'inversify';
import {CollectionFetcher} from '../services/CollectionFetcher/CollectionFetcher';
import {ICollectionFetcher} from '../services/CollectionFetcher/ICollectionFetcher';
import {CollectionManager} from '../services/CollectionManager/CollectionManager';
import {ICollectionManager} from '../services/CollectionManager/ICollectionManager';
import {ExperimentManager} from '../services/ExperimentManager/ExperimentManager';
import {IExperimentManager} from '../services/ExperimentManager/IExperimentManager';
import {Global} from '../services/Global/Global';
import {IGlobal} from '../services/Global/IGlobal';
import {ISiteStorage} from '../services/SiteStorage/ISiteStorage';
import {SiteStorage} from '../services/SiteStorage/SiteStorage';
import {CollectionObservable} from '../widget-player/new/services/CollectionObservable/CollectionObservable';
import {ICollectionObservable} from '../widget-player/new/services/CollectionObservable/ICollectionObservable';
import {ISettingsProvider} from '../widget-player/new/services/SettingsProvider/ISettingsProvider';
import {SettingsProvider} from '../widget-player/new/services/SettingsProvider/SettingsProvider';
import {IWidgetPlayer} from '../widget-player/new/services/WidgetPlayer/IWidgetPlayer';
import {WidgetPlayer} from '../widget-player/new/services/WidgetPlayer/WidgetPlayer';
import {services} from './services';

export function inversifyConfig(container: Container) {
  container.bind<IWixSdk>(services.WixSdk).toConstantValue(WixSdk);
  container.bind<IGlobal>(services.global).to(Global);
  container.bind<ICollectionFetcher>(services.collectionFetcher).to(CollectionFetcher);
  container.bind<ICollectionManager>(services.collectionManager).to(CollectionManager);

  container.bind<ISiteStorage>(services.siteStorage).to(SiteStorage);

  container.bind<ICollectionObservable>(services.collectionObservable).to(CollectionObservable);
  container.bind<IWidgetPlayer>(services.widgetPlayer).to(WidgetPlayer);
  container.bind<IExperimentManager>(services.experimentManager).to(ExperimentManager);
  container.bind<ISettingsProvider>(services.settingsProvider).to(SettingsProvider).inSingletonScope();
}
